"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePageAppBackground = void 0;
var react_1 = __importDefault(require("react"));
var QwilrLogoLettering_svg_1 = __importDefault(require("@ClientAssets/icons/QwilrLogoLettering.svg"));
var colorfulBackground_svg_1 = __importDefault(require("@ClientAssets/Images/createPage/colorfulBackground.svg"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var QWILR_APP_URL = "https://app.qwilr.com";
var CreatePageAppBackground = function () {
    return (react_1.default.createElement("div", { className: "standalone-create-page-app-background", style: {
            backgroundImage: "url(".concat(colorfulBackground_svg_1.default, ")"),
        } },
        react_1.default.createElement("div", { className: "standalone-create-page-app-background__nav-bar" },
            react_1.default.createElement("div", { className: "standalone-create-page-app-background__logo-icon" },
                react_1.default.createElement("a", { href: QWILR_APP_URL, target: "_blank" },
                    react_1.default.createElement(kaleidoscope_1.SVG, { src: QwilrLogoLettering_svg_1.default }))))));
};
exports.CreatePageAppBackground = CreatePageAppBackground;
